import React, { useEffect, useState } from "react";
import secureAxios from "../../utils/secureAxios";
import { useAuth } from "../../contexts/AuthContext";
import { getApiBaseURL } from "../../utils/api";

const TicketComments = ({ ticket }) => {
  const { user } = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const apiBase = getApiBaseURL();
  // const apiBase = process.env.REACT_APP_API_BASE || "";

  const loadComments = async () => {
    try {
      const res = await secureAxios.get(
        `${apiBase}/api/tickets/${ticket.ticket_id}/comments`
      );
      setComments(res.data);
    } catch (err) {
      console.error("Failed to load comments", err);
    }
  };

  useEffect(() => {
    loadComments();
  }, [ticket.ticket_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await secureAxios.post(
        `${apiBase}/api/tickets/${ticket.ticket_id}/comments`,
        {
          user_id: user.user_id,
          comment_text: newComment,
          name: user.name,
        }
      );

      setNewComment("");
      loadComments();
    } catch (err) {
      console.error("Error posting comment", err);
    }
  };

  return (
    <div>
      <h6>Ticket: {ticket.subject}</h6>
      <div className="mb-3 p-2 border bg-light rounded">
        <strong>Description:</strong>
        <p className="mb-0">
          {ticket.description || "No description provided."}
        </p>
      </div>

      <ul className="list-group mb-3">
        {comments.map((comment) => (
          <li key={comment.comment_id} className="list-group-item">
            <strong>{comment.name}:</strong> {comment.comment_text}
          </li>
        ))}
      </ul>
      <form onSubmit={handleSubmit}>
        <textarea
          className="form-control mb-2"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add your comment..."
          required
        />
        <button className="btn btn-secondary btn-sm">Add Comment</button>
      </form>
    </div>
  );
};

export default TicketComments;
